import PropTypes from 'prop-types';
import React from 'react';

import { formatLinkBlockToUrl } from '$utilities/format.js';
import { isLocalURL } from '$utilities/browser.js';
import { Media } from '$partials/media/index.js';
import { slugify } from '../../utilities/slugify.js';
import RichTextWithGlossary from '$partials/glossary/rich-text-with-glossary.jsx';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const ModulePrimaryFeatureBlock = ({
    bodyRichText = null,
    heading = null,
    link = null,
    linkLabel = null,
    media = null,
    smallHeading = null
}) => {
    // misc
    const href = formatLinkBlockToUrl(link);
    const target = isLocalURL(href) ? '_self' : '_blank';
    const rel = isLocalURL(href) ? '' : 'noreferrer noopener';

    // render
    return (
        <div className='relative md:h-screen'>
            <figure className='relative h-full w-full'>
                <Media { ...media } />
            </figure>

            <div className='md:w-full md:absolute md:bottom-0 md:left-0 pointer-events-none z-10'>
                <div className='layout-container layout-left-fill text-white'>
                    <div className='layout-grid-negative-gutter'>
                        <div className='relative md:flex md:flex-wrap'>
                            <div className='md:w-1/12 bg-white' />

                            <div className='md:w-6/12 layout-grid-col-padding pb-30 md:pb-80 pointer-events-auto bg-white'>
                                <div className='pt-40 md:pt-60 text-black'>
                                    {smallHeading && (
                                        <p className='type-style-4'>
                                            {smallHeading}
                                        </p>
                                    )}

                                    {heading && (
                                        <h2 className='type-style-1 mt-10 w-12/12 sm:w-12/12 md:pr-40'>
                                            {heading}
                                        </h2>
                                    )}

                                    {bodyRichText && (
                                        <RichTextWithGlossary
                                            className='type-style-4 mt-20 md:pr-80 rich-text'
                                            html={bodyRichText} />
                                    )}

                                    {linkLabel && (
                                        <div className='mt-30'>
                                            <a
                                                className={`pill-button gtm-${slugify(linkLabel || link?.page?.title)}`}
                                                href={href}
                                                rel={rel}
                                                target={target}>
                                                {linkLabel || link?.page?.title }
                                            </a>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    bodyRichText: PropTypes.string,
    className: PropTypes.string,
    heading: PropTypes.string,
    link: PropTypes.object,
    linkLabel: PropTypes.string,
    media: PropTypes.object,
    smallHeading: PropTypes.string
};


ModulePrimaryFeatureBlock.propTypes = propTypes;

export default ModulePrimaryFeatureBlock;
